/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported dashboard widget kinds.
 */
export enum ReportWidgetKind {
    FUNNEL_STATUS_FUNNEL = 'FUNNEL_STATUS_FUNNEL',
    FUNNEL_STATUS_FIRST_ENTRY_TIMESERIES = 'FUNNEL_STATUS_FIRST_ENTRY_TIMESERIES',
    PROPERTY_TYPE_DISTRIBUTION = 'PROPERTY_TYPE_DISTRIBUTION',
    PROPERTY_INTEREST_RANKING = 'PROPERTY_INTEREST_RANKING',
    USER_ASSIGNMENT_RANKING = 'USER_ASSIGNMENT_RANKING',
}
